/**
 * This build of the webapp, as a consent record names it: the commit it
 * was built from, cut to 12 characters, set by vite.config.ts from the
 * deploy's `GITHUB_SHA`, or `dev` for a local build. Organizations keeps
 * it beside every record, with where the record came from.
 */
export const BUILD: string = import.meta.env.VITE_BUILD || "dev";
